import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { LoaderService } from '@app/_core/services/loader.service';
import { LoginService } from '@app/_core/services/login.service';
import { SecurityService } from '@app/_core/services/security.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { UserService } from '@app/_core/services/user.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { HubManager } from '@app/pages/hubs/common/Hubs';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-switch-client',
  templateUrl: './switch-client.component.html',
  styleUrl: './switch-client.component.scss'
})
export class SwitchClientComponent implements OnInit, AfterViewInit {

  selectedClient: any = {};
  @Input() accessibleClients: any;
  @Input() voiceCountInterval:any;
  returnUrl = '';
  queueInterval: any;
  res;
  userinterval: any;
  constructor(
    public bsModalRef: BsModalRef,
    private cdRef: ChangeDetectorRef,
    private webStorageService: WebStorageService,
    private loginService: LoginService,
    // private mainController: MainControllerComponent,
    private userService: UserService,
    private tmqueueService: TmQueueService,
    private appService: AppService,
    private securityService: SecurityService,
    private loaderService: LoaderService,
    private hubManager: HubManager,
    private route: ActivatedRoute,
    private router: Router,
  ) {

  }

  ngAfterViewInit(): void {
  }
  ngOnInit(): void {
    const companyCode = Utils.fetch('clientAbbreviation');
   // console.log(this.accessibleClients)
   this.accessibleClients = this.accessibleClients.filter(i => i.abbreviation != companyCode );
    // let index = this.accessibleClients.findIndex(item => item.abbreviation == companyCode);
    //         console.log(index)
    //         if (index !== -1) {
    //           this.accessibleClients.splice(index, 1);
    //         }
    //console.log(this.accessibleClients)
    this.selectedClient.value = -1
   

  }

  onSwitchClientChange() {
    const sourceValue = this.selectedClient.value;

    if(this.selectedClient.value){
      this.bsModalRef.hide();
    }
    if (this.voiceCountInterval) {
      clearInterval(this.voiceCountInterval);
    }

    this.userinterval = this.appService.getUserIntervalValue();
    if ( this.userinterval) {
      clearInterval( this.userinterval);
    }
    //console.log( this.userinterval)
    // console.log(sourceValue);

    // localStorage.clear();
    // sessionStorage.clear();
    // this.loaderService.display(false);
    // this.hubManager.eAppWillCloseHandler();
    //   this.hubManager.setTMHubJoinedStatus(false);
    // // this.appService.setblockGetUserCalls(true);
    this.res =  this.loginService.switchClientLoggedIn(sourceValue,this.voiceCountInterval,this.userinterval)

  // if(!this.res){
  //   if (this.voiceCountInterval) {
  //     clearInterval(this.voiceCountInterval);
  //   }
 
  //   this.userinterval = this.appService.getUserIntervalValue();
  //   if ( this.userinterval) {
  //     clearInterval( this.userinterval);
  //   }
  // }


    // this.userService.ChangeClientContext(sourceValue).subscribe(res => {
    //   console.log(res, 'on switch client')
    //   if (res) {
    //     //  const loginDetails = this.loginService.getLoggedIn()
    

    // // this.router.navigate([this.selectedClient.value + '/Queue']);
    // // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/Queue';
    //     //  console.log(loginDetails);
         

    //     //logout
    //     // this.logout();

       
       
    //   }

    // })

  }
  onCloseHandled() {
    this.bsModalRef.hide();
  }

  logout(){
    this.tmqueueService.setUserStatus(2, null).subscribe((result: any) => {
      this.appService.setCurrentMenu(null);
      Utils.store('clientAbbreviation', null);
      this.securityService.clientAbbr = null;
      this.securityService.setUserData(null);
      this.userService.logout();
    });
  }
}
